import React, { useState, useCallback } from "react";
// import SearchIcon from '../../assets/search.png';
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import './SearchComponent.css';
import _ from 'lodash';

function SearchComponent({ placeholder, onSearch, CreateButtonTitle, setOpenCreateSettings, canCreate }) {
    const [query, setQuery] = useState("");

    const debounceSearch = useCallback(
        _.debounce((query) => {
            console.log('debounce', query)
            onSearch(query)
        }, 600),
        [onSearch]
    )

    const handleSearchFuntionality = (event) => {
        const newQuery = event.target.value;
        setQuery(newQuery);
        debounceSearch(newQuery);
        // if (!event.target.value) return setSearchResults(agentsData);

        // const filterResultsArray = agentsData.filter(
        //   (data) => {
        //     const getAgentDesc = data.attributes.filter(item => item.attribute_name === 'agent_desc')[0]?.attribute_value;
        //     const results = data.agent_name
        //       .toLowerCase()
        //       .includes(event.target.value.toLowerCase()) ||
        //       getAgentDesc.toLowerCase().includes(event.target.value.toLowerCase());
        //     return results;
        //   }
        // );

        // setSearchResults(filterResultsArray);
    };

    return (
        <>
            <div className="SearchBar">
                <div className="col-4 d-flex" style={{ padding: '2px' }}>
                    <div className="input-group input-group-lg">
                        <input
                            type="text"
                            className="searchFormControl"
                            placeholder={placeholder}
                            onChange={handleSearchFuntionality}
                            style={{ backgroundColor: '#ffffff' }}
                        />
                        {/* <span className="input-group-text" id="ai_agent_search" style={{backgroundColor:"#DDEFE8", border:'2px solid #D0D0CE'}}>
                        <img src={SearchIcon} alt="SearchIcon"/>
                    </span> */}
                    </div>
                </div>
                {canCreate &&
                    <div className="col-4 d-flex justify-content-end px-3">
                        <Button
                            variant="contained"
                            classes="btn-primary"
                            size="large"
                            onClick={() => setOpenCreateSettings(true)}
                            className="agentButton"
                            startIcon={<AddIcon />}
                        >
                            {CreateButtonTitle}
                        </Button>
                    </div>
                }
            </div>
        </>
    );
}

export default SearchComponent;

